<div>
  <p-toast position="top-center"></p-toast> 
  <p-dialog [(visible)]="tableDataIsLoading" [showHeader]="false" [resizable]="false" [modal]="true"
        [focusOnShow]="false" class="progress-overlay">
    <div style="width: 200px; height: 150; padding-top: 5%" class="text-center">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
    </div>
  </p-dialog>
  <p-confirmDialog header="Confirmation" ></p-confirmDialog>

  <!-- Filter Controls Outside TreeTable -->
  <div class="variance-filter-toolbar" [class.variance-filter-toolbar--embedded]="isAuditor">
    <div class="variance-filter-controls">
      <!-- Start of Search Bar For Big Screen -->
      <div *ngIf="screenWidth > 767">
        <div class="search-bar variance-table-search">
          <i tabindex="0" class="pi pi-search mr-2" pTooltip="click to search" tooltipPosition="bottom" (click)="submitGlobalFilter()" (keydown.enter)="submitGlobalFilter()" style="margin: 4px 2px 0 0"></i>
          <input type="text" placeholder="Table Search" pInputText 
            [(ngModel)]="filter.globalSearch"
            (keyup.enter)="submitGlobalFilter()"
            class="searchStyle"/>
        </div>
      </div>
      <!-- End of Search Bar For Big Screen -->

      <!-- Start of Search Bar For Small Screen -->
      <div *ngIf="screenWidth <= 767" class="variance-mobile-search">
        <span pTooltip="Search" tooltipPosition="bottom">
          <p-button (click)="showSearchDialog()" icon="pi pi-search" styleClass="p-button-secondary"></p-button>
        </span>
      </div>
      <!-- End of Search Bar For Small Screen -->

      <div *ngIf="!isAuditor" class="variance-quick-time-filter">
        <p-select [options]="quickTimeOptions"
                  [ngModel]="lookbackPeriod"
                  (onChange)="lookbackPeriodChange.emit($event.value)"
                  aria-label="Quick time filter"
                  styleClass="quick-time-select">
        </p-select>
      </div>

      <div id="serviceGrpApp" class="variance-filter-group">
        <app-service-grp-select [defaultService]="filter.serviceGroup" (serviceGrpSelected)="onServiceGrpChanged($event)"></app-service-grp-select>
      </div>
      
      <div id="locationApp" class="variance-location-filter" *ngIf="active || locationInitialized">
        <app-location-select 
          #locationSelectComp 
          [user]="authService.user" 
          [footprint]="footprint"
          [deId]="deId" 
          [filter]="locationSelectFilter" 
          [showReset]="false"
          (locationSelected)="onLocationChanged($event)" 
          (initComplete)="onLocationSelectInitialized($event)"
          (onClickReset)="deSelectChecks()"
          (clearTableSearch)="clearTableSearch()"
          >
        </app-location-select>
      </div>
    </div>

    <div class="variance-filter-actions">
      <app-refresh-button class="variance-filter-action" (refresh)="refreshToInitialState()"></app-refresh-button>
      
      <div class="variance-filter-action">
        <span pTooltip="Print" tooltipPosition="bottom">
          <p-button icon="pi pi-print" styleClass="p-button-secondary" (click)="printVariance()"></p-button>
        </span>
      </div>
      
      <div *ngIf="isAuditor" class="variance-filter-action">
        <span pTooltip="Email Share" tooltipPosition="bottom">
          <p-button icon="pi pi-share-alt" styleClass="p-button-secondary" (click)="shareVariances()"></p-button>
        </span>
      </div>
      
      <div class="variance-filter-action">
        <span [pTooltip]="getFilterTooltip()" tooltipPosition="left">
          <p-button icon="pi pi-filter" styleClass="p-button-secondary" (click)="openFilterModal()"></p-button>
          <!-- Took out [disabled]="(!dataLoaded || (deId && isAuditor))" it doesn't work when reopenning the filter -->
        </span>
      </div>
    </div>
  </div>

  <p-treetable
    #variancett
    [value]="this.varianceNodes"
    [paginator]="true" 
    [rows]="20"
    [totalRecords]="totalCount"
    [lazy]="true"
    (onLazyLoad)="loadRecordsLazy($event)"
    (onNodeExpand)="onNodeExpand($event)"
    paginatorPosition="bottom"
  >

    <ng-template pTemplate="header">
      <tr>
         <th class="share-col-header" style="width:85px; border-top-left-radius: 10px;">
          <!-- <input type="checkbox" name="list_name" [(ngModel)]="masterSelected" (click)="checkUncheckAll($event)" class="SelectAllCheck"> -->
          <p-checkbox [(ngModel)]="masterSelected" [binary]="true" (onChange)="checkUncheckAll($event)" class="share-check"></p-checkbox>
        </th>
         <th [ttSortableColumn]="'patientName'" colspan="2">
          Patient Name
          <p-treeTableSortIcon [field]="'patientName'"></p-treeTableSortIcon>
        </th>
        <th [ttSortableColumn]="'mrnNum'">
          Patient ID
          <p-treeTableSortIcon [field]="'mrnNum'"></p-treeTableSortIcon>
        </th>
         <th *ngIf="include_csn" colspan="2">
          CSN
        </th>
        <th [ttSortableColumn]="'medGroupName'">
            Medication
          <p-treeTableSortIcon [field]="'medGroupName'"></p-treeTableSortIcon>
        </th>
        <th [ttSortableColumn]="'bedDev'">
            Stock Area
          <p-treeTableSortIcon [field]="'bedDev'"></p-treeTableSortIcon>
        </th>
        <th [ttSortableColumn]="'lanID'">
            User ID
          <p-treeTableSortIcon [field]="'lanID'"></p-treeTableSortIcon>
        </th>
         <th [ttSortableColumn]="'employeeName'">
            User Name
          <p-treeTableSortIcon [field]="'employeeName'"></p-treeTableSortIcon>
        </th>
        <th [ttSortableColumn]="'adminGroup'">
          <span>
            Role
          </span>
          <p-treeTableSortIcon [field]="'adminGroup'"></p-treeTableSortIcon>
        </th>
         <th [ttSortableColumn]="'amount'">
            Quantity
          <p-treeTableSortIcon [field]="'amount'"></p-treeTableSortIcon>
        </th>
        <th [ttSortableColumn]="'uom'">
            Unit of Measure
          <p-treeTableSortIcon [field]="'uom'"></p-treeTableSortIcon>
        </th>
        <th [ttSortableColumn]="'varDate'">
          Date/Time
          <p-treeTableSortIcon [field]="'varDate'"></p-treeTableSortIcon>
        </th>
        <th [ttSortableColumn]="'transType'">
           Transaction Type
          <p-treeTableSortIcon [field]="'transType'"></p-treeTableSortIcon>
        </th>
        <th [ttSortableColumn]="'resolutionCoding'" style="width:190px; border-top-right-radius: 10px;">
          Variance Type<br/>
          <span class="practice-issues-indicator">(* Indicates Practice Issues)</span>
          <p-treeTableSortIcon [field]="'resolutionCoding'"></p-treeTableSortIcon>
        </th>  
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <ng-container [ngSwitch]="getNodeLevel(rowNode)">
        <tr *ngSwitchCase="1" class="maap-row-level1">
          <td>
            <p-checkbox [(ngModel)]="rowData.isSelected" (ngModelChange)="isPrint($event, rowData)" [binary]="true" class="share-check"></p-checkbox>
          </td>
          <td colspan="2" style="text-align: left;padding-left: 30px !important">
            <p-treetable-toggler [rowNode]="rowNode">
              <ng-template>
              </ng-template>
            </p-treetable-toggler>
            <span style="cursor:pointer;font-size: 14px;">{{isDeId(formatName(rowData.patientName))}}</span>
          </td>
          <td>{{isDeId(rowData.mrnNum)}}</td>
          <td *ngIf="include_csn" colspan="2">{{isDeId(rowData.csn)}}</td>
          <td pTooltip="{{rowData.medGroupName}}">{{rowData.medGroupName | slice:0:10}}{{rowData.medGroupName.length > 10 ? '..': ''}}</td>
          <!-- <td>{{rowData.medId}}</td> -->
          <td>{{isDeId(rowData.loc)}}</td>
          <td>{{isDeId(rowData.lanId)}}</td>
          <td>{{isDeId(formatName(rowData.employeeName))}}</td>
          <td>{{rowData.adminGroup}}</td>
          <td style="text-align:center">{{rowData.var | formatQuantity}}</td>
          <td>{{rowData.uom}}</td>
          <td>{{formatDateCustom(rowData.varDateString)}}</td>
          <!-- <td>{{rowData.varDateString |date:'MM/dd/yyyy | HH:mm'}}</td> -->
          <td>
            <img tabindex="0" class="variance-link-image" *ngIf="rowData.isLinked" src="/assets/images/icon_Linked-Transaction.png" alt="Linked transaction details" (click)="openLinkedRecordsModal(rowData)" (keydown.enter)="openLinkedRecordsModal(rowData)">
            <span *ngIf="rowData.transType==='Verified'"> <i ng-reflect-ng-class="pi pi-fw pi-chevron-right" class="pi pi-check pi-fw"></i> Verified </span>
          </td>
          <td class="position-relative">
            <div id="colorBox" [ngClass]="getResolutionBg(rowData.resolutionCoding)">
              <div class="position-relative" style="font-size: 12px; font-weight: 600; display:flex; justify-content: center;">{{ rowData?.resolutionCoding }}<span class="astrick-issues" *ngIf="rowData.practiceIssue?.length">*</span></div>
            </div>
            <div class="iconBox">
              <img tabindex="0"
                class="maap-icon-Style float-right"
                src="/assets/images/icon_edit.png"
                alt="Edit notes"
                (click)="showCommentEdit(rowData)" (keydown.enter)="showCommentEdit(rowData)">
              </div>
          </td>
      
        </tr>
        <tr *ngSwitchCase="2" class="maap-row-level2">
          <td *ngIf="include_csn" colspan="14" [class]="rowClass(rowData.label)">
            <p-treetable-toggler [rowNode]="rowNode"></p-treetable-toggler>
            <span tabindex="0" style="cursor:pointer"
              (click)="$event.currentTarget.previousSibling.children[0].click()" (keydown.enter)="$event.currentTarget.previousSibling.children[0].click()">{{rowData.label}}</span>
          </td>
          <td *ngIf="!include_csn" colspan="14" [class]="rowClass(rowData.label)">
            <p-treetable-toggler [rowNode]="rowNode"></p-treetable-toggler>
            <span tabindex="0" style="cursor:pointer"
              (click)="$event.currentTarget.previousSibling.children[0].click()" (keydown.enter)="$event.currentTarget.previousSibling.children[0].click()">{{rowData.label}}</span>
          </td>
        </tr>
        <tr *ngSwitchCase="3" [class]="getChildRowClass(rowNode.parent.data.label)" class="maap-row-level3">
          <ng-container *ngIf="rowNode.parent.data.label==='WASTE RECONCILIATION';">
            <td [colspan]="(include_csn===false) ? 13:15">
              <div class="row maap-reconciliation-form">
                <div class="col-md-2 mt-2 ">
                  <div class="form-group text-center">
                    <label>NOT RECEIVED:</label>
                    <br>
                    <input type="checkbox" disabled [(ngModel)]="rowNode.parent.parent.data.notRecieved"
                      class="form-control" style="width:20px; display:inline-block">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row">
                    <div class="col-md-12 mt-1">
                      <div class="form-group">
                        <label>Waste Amount: {{rowNode.parent.parent.data.wasteAmountRecieved | formatQuantity}}
                          {{rowNode.parent.parent.data.wasteUOM2}}</label>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2">
                      <div class="form-group">
                        <label>Waste Discrepancy: {{rowNode.parent.parent.data.var | formatQuantity}}
                          {{rowNode.parent.parent.data.wasteUOM2}}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-2">
                  <div class="form-group">
                    <label>Practice Issue</label>
                    <br />
                    <p>{{rowNode.parent.parent.data.practiceIssue}}</p>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Begin Waste Assay Row -->  
          <ng-container *ngIf="rowNode.parent.data.label==='WASTE ASSAY'">
            <td colspan="14">
              <div class="row maap-assay-form">
                <div class="col-md-3 mt-2 ">
                  <div class="row">
                    <div class="col-md-12 mt-1">
                      <div class="form-group">
                        <label>Unique ID: {{rowNode.parent.parent.data.serialIdentifier}}</label>                       
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>NOT PERFORMED:</label>
                        <input type="checkbox" [disabled]="true" [(ngModel)]="rowNode.parent.parent.data.notPerformed"                          
                          style="width:20px; display:inline-block" class="form-control maap-ac-input-checkbox">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Practice Issue: </label>
                        <br/>
                        {{rowNode.parent.parent.data.practiceIssue}}                                              
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-2">
                  <div class="row">
                    <div class="col-md-12 mt-1">
                      <div class="form-group">
                        <label>1st Assay Results (%): {{rowNode.parent.parent.data._1stAssayResults}}</label>
                      </div>
                    </div>
                    <div class="col-md-12 mt-1">
                      <div class="form-group">
                        <label>2nd Assay Results (%): {{rowNode.parent.parent.data._2ndAssayResults}}</label>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2">
                      <div class="form-group">
                        <label>3rd Assay Results (%): {{rowNode.parent.parent.data._3rdAssayResults}}</label>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-md-3 mt-2">
                  <div class="row">
                    <div class="col-md-12 mt-1">
                      <div class="form-group">
                        <label>IN SOURCE: </label>
                        <input type="checkbox" [disabled]="true" [(ngModel)]="rowNode.parent.parent.data._InSource"
                          style="width:20px; display:inline-block" class="form-control maap-ac-input-checkbox">
                      </div>
                    </div>
                    <div class="col-md-12 mt-1">
                      <div class="form-group">
                        <label>OUT SOURCE: </label>
                        <input type="checkbox" [disabled]="true" [(ngModel)]="rowNode.parent.parent.data._OutSource"                          
                          style="width:20px; display:inline-block" class="form-control maap-ac-input-checkbox">
                      </div>
                    </div>
                    <div class="col-md-12 mt-2">
                      <div class="form-group">
                        <label>COMMERCIAL: </label>
                        <input type="checkbox" [disabled]="true" [(ngModel)]="rowNode.parent.parent.data._Commercial"                          
                          style="width:20px; display:inline-block" class="form-control maap-ac-input-checkbox">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-2">
                  <div class="row">
                    <div class="col-md-12 mt-1">
                      <div class="form-group">
                        <label>Pending HPLC Result:</label>
                        <input type="checkbox" [disabled]="true" [(ngModel)]="rowNode.parent.parent.data._PendingHPLCResults"                          
                          style="width:20px; display:inline-block" class="form-control maap-ac-input-checkbox">
                      </div>
                    </div>
                    <div class="col-md-12 mt-1">
                      <div class="form-group">
                        <label>HPLC Result (%): {{rowNode.parent.parent.data._HPLCAssayResults}}</label>
                      </div>
                    </div>
                    <div class="col-md-12 mt-1">
                      <!-- _PendingLabResults to be removed
                        <div class="form-group">
                        <label>Pending LAB Results (%): {{rowNode.parent.parent.data._PendingLabResults}}</label>
                        </div>
                      -->
                      <div class="form-group">
                        <label>Assay Risk Score: {{rowNode.parent.parent.data._AssayRiskScore}}</label>
                      </div>
                    </div>
                  </div>
                </div>            
              </div>
            </td>
          </ng-container>
          <!-- End Waste Assay Row-->
          <ng-container *ngIf="!['WASTE ASSAY','WASTE RECONCILIATION'].includes(rowNode.parent.data.label)">
            <ng-container *ngIf="rowData?rowData['adminId']:false; else rowUndefined">
              <td style="width:85px;"></td>
              <td colspan="2" style ="align-items: right;">
                {{isDeId(formatName(rowData.patientName))}}
              </td>
              <td>{{isDeId(rowData.mrnNum)}}</td>
              <td *ngIf="include_csn" colspan="2">{{isDeId(rowData.csn)}}</td>
              <td pTooltip="{{rowData.medDesc}}">{{rowData.medDesc | slice:0:10}}{{rowData.medDesc.length > 10 ? '..': ''}}</td>
              <td>{{rowData.loc}}</td>
              <td>{{isDeId(rowData.lanId)}}</td>
              <td>{{isDeId(formatName(rowData.employeeName))}}</td>
              <td>{{rowData.adminGroup}}</td>
              <td style="text-align: center;">{{rowData.var | formatQuantity}}</td>
              <td style="text-align: left;">{{rowData.uom}}</td>
              <td>{{formatDateCustom(rowData.varDateString)}}</td>
              <td>
                <div style="display: flex; flex-direction: row;">
                  <div [ngClass]="(rowNode.parent.data.label === 'EHR Data')?'ehrChild':'adcChild'">
                    {{rowData.transType}}
                  </div>
                  <div style="flex-shrink: 1; width: 30%; height: 100%" *ngIf="rowNode.parent.data.label === 'EHR Data'" ptooltip="Additional EHR Notes" tooltipPosition="bottom">
                    <span tabindex="0" class="pi pi-book" style="transform:scale(0.85)" (click)="openOrders(rowData)" (keydown.enter)="openOrders(rowData)"></span>
                  </div>
                </div>
              </td>
              <td></td>
              <!-- <td [ngClass]="getResolutionBg(rowData.resolutionCoding)">{{rowData.resolutionCoding}}</td> -->
              <!-- <td colspan=1 [ngClass]="getResolutionBg(rowData.resolutionCoding)">{{rowData.resolutionCoding}}</td> -->
            </ng-container>
          </ng-container>
            <ng-template #rowUndefined>
              <td colspan="14" class="text-center" *ngIf="rowNode.parent.data.label!=='Add Transaction';">
                <span class="font-weight-bold font-italic no-transaction-message">No Transaction Record</span>
              </td>
               <ng-container *ngIf="rowNode.parent.data.label==='Add Transaction';" ngOnInit="OpenAddTransaction()">
                <ng-container *ngIf="getAddTransDraft(rowNode) as addTransDraft">
                  <td class="form-items-link" colspan="14">
                    <div class="add-transaction-form-grid">
                      <!-- Patient Information Section -->
                      <div class="form-section">
                        <h4 class="section-title">Patient Information</h4>
                        <div class="form-row">
                          <div class="form-group">
                            <label for="mrnNum">Patient ID</label>
                            <ng-select (change)="updateAutoFill(addTransDraft.addTransAutoFill.patientId, 'patientId', addTransDraft.parentRow.id)" [(ngModel)]="addTransDraft.addTransAutoFill.patientId" [items]="filterOptions.patientId" (search)="searchWithAutoComplete($event,'patientId','patientid')" appendTo="body"></ng-select>
                          </div>
                          <div class="form-group">
                            <label for="patientName">Patient Name</label>
                            <div class="readonly-field">{{isDeId(addTransDraft.addTransAutoFill?.patientName)}}</div>
                          </div>
                        </div>
                      </div>

                      <!-- Administrator Information Section -->
                      <div class="form-section">
                        <h4 class="section-title">Administrator Information</h4>
                        <div class="form-row">
                          <div class="form-group">
                            <label for="lanID">User ID</label>
                            <ng-select (change)="updateAutoFill(addTransDraft.addTransAutoFill.adminId, 'adminId', addTransDraft.parentRow.id)" [(ngModel)]="addTransDraft.addTransAutoFill.adminId" [items]="filterOptions.adminId" (search)="searchWithAutoComplete($event,'adminId','adminid')" appendTo="body"></ng-select>
                          </div>
                          <div class="form-group">
                            <label for="employeeName">User Name</label>
                            <div class="readonly-field">{{isDeId(addTransDraft.addTransAutoFill?.employeeName)}}</div>
                          </div>
                          <div class="form-group">
                            <label for="adminGroup">Role</label>
                            <div class="readonly-field">{{addTransDraft.addTransAutoFill?.adminGroup}}</div>
                          </div>
                        </div>
                      </div>

                      <!-- Transaction Details Section -->
                      <div class="form-section">
                        <h4 class="section-title">Transaction Details</h4>
                        <div class="form-row">
                          <div class="form-group">
                            <label for="loc">Stock Area</label>
                            <ng-select [items]="filterOptions.loc" [(ngModel)]="addTransDraft.addTransAutoFill.loc" appendTo="body"></ng-select>
                          </div>
                          <div class="form-group">
                            <label for="transType">Transaction Type</label>
                            <ng-select [items]="filterOptions.transactionType" [(ngModel)]="addTransDraft.addTransAutoFill.transType" (search)="searchWithAutoComplete($event,'transType','transType')" appendTo="body"></ng-select>
                          </div>
                          <div class="form-group">
                            <label for="varDateString">Transaction Date/Time</label>
                            <p-datepicker [(ngModel)]="addTransDraft.addTransAutoFill.varDateString" appendTo="body" name="varDateString"
                                          inputId="calendar-24h" [showTime]="true" [hourFormat]="24"/>
                          </div>
                        </div>
                      </div>

                      <!-- Medication Information Section -->
                      <div class="form-section">
                        <h4 class="section-title">Medication Information</h4>
                        <div class="form-row">
                          <div class="form-group form-group-wide">
                            <label for="medDesc">MED DESC</label>
                            <ng-select (change)="updateAutoFill(addTransDraft.addTransAutoFill.medDesc, 'medDesc', addTransDraft.parentRow.id)" [items]="filterOptions.medDescription" [(ngModel)]="addTransDraft.addTransAutoFill.medDesc" (search)="searchWithAutoComplete($event,'medDesc','medDesc')"></ng-select>
                          </div>
                          <div class="form-group">
                            <label for="qty">QUANTITY</label>
                            <p-inputNumber inputId="minmaxfraction" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="10" [(ngModel)]="addTransDraft.addTransAutoFill.amount" inputId="integeronly" styleClass="w-100"></p-inputNumber>
                          </div>
                          <div class="form-group">
                            <label for="uom">UOM</label>
                            <ng-select [items]="filterOptions.uom" [(ngModel)]="addTransDraft.addTransAutoFill.uom" appendTo="body"></ng-select>
                          </div>
                        </div>
                      </div>

                      <!-- Resolution & Comments Section -->
                      <div class="form-section full-width">
                        <h4 class="section-title">Variance Type & Comments</h4>
                        <div class="form-row">
                          <div class="form-group form-group-wide">
                            <label for="Practice Issues">Practice Issues</label>
                            <ng-select multiple="true" [items]="commentModal.practiceIssueOptions" [(ngModel)]="addTransDraft.addTransPracticeIssues" appendTo="body"></ng-select>
                          </div>
                          <div class="form-group form-group-wide">
                            <label for="Resolution Code">Variance Type</label>
                            <ng-select (change)="addTransResolutionUpdate(addTransDraft.parentRow.id)" [items]="commentModal.resolutionOptions" [(ngModel)]="addTransDraft.addTransResolutionCoding" appendTo="body"></ng-select>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group form-group-full">
                            <label>Comment</label>
                            <textarea
                              class="form-control"
                              [(ngModel)]="addTransDraft.addComment"
                              rows="3"
                            ></textarea>
                          </div>
                        </div>
                      </div>

                      <!-- Submit Button -->
                      <div class="form-actions">
                        <p-button 
                          label="Add Transaction" 
                          icon="pi pi-plus"
                          variant="outlined"
                          severity="info" 
                          (click)="submitAddOn(rowNode)"
                          [disabled]="!addTransDraft.addTransAutoFill.varDateString || !addTransDraft.addTransAutoFill.amount || !addTransDraft.addTransAutoFill.transType">
                        </p-button>
                      </div>
                    </div>
                  </td>    
                </ng-container>
              </ng-container>
            </ng-template>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="paginatorfirstpagelinkicon">
      <p-button type="button" icon="pi pi-angle-double-left" styleClass="p-button-text"></p-button>
    </ng-template>
    <ng-template pTemplate="paginatorpreviouspagelinkicon">
      <p-button type="button" icon="pi pi-angle-left" styleClass="p-button-text"></p-button>
    </ng-template>
    <ng-template pTemplate="paginatornextpagelinkicon">
      <p-button type="button" icon="pi pi-angle-right" styleClass="p-button-text"></p-button>
    </ng-template>
    <ng-template pTemplate="paginatorlastpagelinkicon">
      <p-button type="button" icon="pi pi-angle-double-right" styleClass="p-button-text"></p-button>
    </ng-template>
  </p-treetable>
  <p-dialog header="Linked Transactions"  
    [(visible)]="showLinkedRecordsModal" [style]="{width: '90vw'}" class="popUpHeader">
    <app-linked-records-modal (linkModalRecordsRemoved)="linkModalRecordsRemoved($event)" #linkRecordsModal [selectedRow]="selectedRow" (completed)="linkedRecordsModalClosed()">
  </app-linked-records-modal>
  </p-dialog>

  <div class="card flex justify-content-center">
    <p-dialog [(visible)]="showLinkTransactions"  [style]="{width: '90vw'}">
      <p-header>
        <h4>LINK TRANSACTION</h4>
        <!-- {{ addTransAutoFill["employeeName"] }} ID:{{ addTransAutoFill["adminId"] }} -->
        <span style="margin-left: 10%">
          <!-- <input type="text" pInputText placeholder="Table Search" [(ngModel)]="this.filter.linkTransaction.globalSearch"
            (keyup.enter)="submitIndvActivityFilter()" class="onclick='this.blur();'" style="width: 65%; max-width:350px; margin: 8px 5px 0 0; padding-right: 20px"/>
            <div class="maap-search-icon">
              <i tabindex="0" class="pi pi-search mr-2" pTooltip="click to search" tooltipPosition="bottom" (click)="submitGlobalFilter()" style="margin: 4px 2px 0 0"></i>
              <i tabindex="0" class="pi pi-times" pTooltip="click to clear" (click)="clearFilter()" tooltipPosition="bottom" style="margin: 4px 2px 0 0"></i>
            </div> -->
            <!-- <button type="button" (click)="openLinkFilterDialog()" style="margin-right: 8px;"  class="btn btn-sm btn-light">Filter</button> -->
            <button class="btn btn-sm btn-light ml-3 " (click)="linkTransaction()" type="button">Link</button> 
          </span>
        </p-header>
      <app-link-transaction [items]="getActiveAddTransDraft()?.parentRow?.uniqueKey2 || uniqueKey2" (selectedData)="selectedDataValue($event)" *ngIf="showLinkTransactions"></app-link-transaction>
    </p-dialog>
  </div>

  <p-dialog header="View/Add New Comments and View/Update Variance Type" class="filterHeader" (onShow)="onShowModal()" (onHide)="onHideModal()" [style]="{width: '60vw'}" appendTo="body"
    [(visible)]="commentDialog">
    <app-comment-modal #commentModal [selectedRow]="selectedRow" [deId]="deId" (completed)="submitMessageCompleted($event)">
    </app-comment-modal>
    
  </p-dialog>
 
  <p-dialog header="FILTER DATA" class="filterHeader" styleClass="variance-advanced-filter-dialog" [style]="{width: '800px', minWidth: '600px'}" appendTo="body" [(visible)]="filterDialog">
    <div class="row justify-content-center" style="margin: 0;">
      <div class="col-md-6 d-flex flex-column align-items-center">
        <div class="form-group w-75 mx-auto">
          <!-- <label>Start Date</label>
          <p-datepicker appendTo="body" (onSelect)="updateEndDate()" [(ngModel)]="filter.transactionStartDate" inputId="start_date"></p-datepicker> -->
          <mat-form-field class="variance-filter-date">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" [(ngModel)]="filter.transactionStartDate" (dateChange)="updateEndDate()">
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="form-group w-75" style="margin: 0 auto;">
          <label for="pwd">User ID</label>
          <ng-select multiple="true" bindLabel="label" bindValue="value" appendTo=".variance-advanced-filter-dialog" [(ngModel)]="filter.adminId" [items]="filterOptions.adminId" (search)="searchWithAutoComplete($event,'adminId','adminid')"></ng-select>
         
        </div>
        <div *ngIf="include_csn" class="form-group w-75" style="margin: 0 auto;">
          <label>CSN</label>
          <ng-select multiple="true" [(ngModel)]="filter.csn" [items]="filterOptions.csn" (search)="onCsnSearch($event)" [loading]="isCsnLoading"
                     bindValue="value" (clear)="resetCode('csn')" appendTo=".variance-advanced-filter-dialog" (change)="onCsnSelected()"  placeholder="Start typing to search CSNs" [virtualScroll]="true">
          </ng-select>
        </div>
        <div class="form-group w-75" style="margin: 0 auto;">
            <label>Role</label>
            <!-- <p-autoComplete [(ngModel)]="filter.UserType" [suggestions]="filterOptions.adminId"  (completeMethod)="searchWithAutoComplete($event,'adminId','admintype')"></p-autoComplete> -->
            <ng-select multiple="true" bindValue="value" (clear)="resetCode('adminType')" appendTo=".variance-advanced-filter-dialog" [(ngModel)]="filter.adminType" [items]="filterOptions.adminType" [virtualScroll]=true [searchFn]="ngSelectSearch"></ng-select>
        </div>
        <div class="form-group w-75" style="margin: 0 auto;">
          <label>Stock Area</label>
          <ng-select multiple="true" bindValue="value" (clear)="resetCode('bedDev')" appendTo=".variance-advanced-filter-dialog" [items]="filterOptions.loc" [(ngModel)]="filter.bedDev" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
        </div>
        <div class="form-group w-75" style="margin: 0 auto;">
          <label for="pwd">Variance Type</label>
          <ng-select multiple="true" bindValue="value" (clear)="resetCode('resCode')" appendTo=".variance-advanced-filter-dialog" [items]="filterOptions.resolutionCoding" [(ngModel)]="filter.resolution" [virtualScroll]=true> </ng-select>
        </div>
        <div class="form-group w-75" style="margin: 0 auto;">
          <label for="pwd">Practice Issues</label>
          <ng-select multiple="true" bindValue="value" (clear)="resetCode('practiceIssue')" appendTo=".variance-advanced-filter-dialog" [items]="filterOptions.practiceIssue" [(ngModel)]="filter.practiceIssue" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group w-75" style="margin: 0 auto;">
            <!-- <label>End Date</label>
            <p-datepicker appendTo="body" [(ngModel)]="filter.transactionEndDate" inputId="end_date"></p-datepicker> -->
            <mat-form-field class="variance-filter-date">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="endPicker" [(ngModel)]="filter.transactionEndDate">
              <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="form-group">
          <label>Patient ID:</label>
          <ng-select multiple="true" appendTo=".variance-advanced-filter-dialog" [(ngModel)]="filter.mrnNum" [items]="filterOptions.patientId" (search)="searchWithAutoComplete($event,'patientId','patientid')"></ng-select>
        </div>
        <!-- <div class="form-group">
          <label>PATIENT NAME</label><br />
          <ng-select multiple="true" [(ngModel)]="filter.ptname" [items]="filterOptions.patients"  (search)="searchWithAutoComplete($event,'patients','patientname')"></ng-select>          
        </div> -->
        <div class="form-group">
          <label>Medication Group</label>
          <ng-select multiple="true" bindValue="value" (clear)="resetCode('medGroupName')" appendTo=".variance-advanced-filter-dialog" [items]="filterOptions.medGroupName" [(ngModel)]="filter.medGroup" (change)="onMedGroupChanges()" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
        </div>
        <div class="form-group">
          <label>Medication Description</label>
          <ng-select multiple="true" bindValue="value" (clear)="resetCode('description')" appendTo=".variance-advanced-filter-dialog" [items]="filterOptions.medDescription" [(ngModel)]="filter.medDesc" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
        </div>
        <div class="form-group">
          <label>Risk Level</label>
          <ng-select multiple="true" bindValue="value" (clear)="resetCode('riskLevel')" appendTo=".variance-advanced-filter-dialog" [items]="filterFixedOptions.riskLevels" [(ngModel)]="filter.riskLevel" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
        </div>
        <div class="form-group">
          <label>Verified Status</label>
          <ng-select multiple="false" bindValue="value" (clear)="resetCode('transType')" appendTo=".variance-advanced-filter-dialog" [items]="filterFixedOptions.transType" [(ngModel)]="filter.transType" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
        </div>
        <div class="form-group w-75 mx-auto" style="margin-top: 16px;">
          <div class="d-flex" style="gap: 8px;">
            <p-button label="Clear" icon="pi pi-trash" severity="info" styleClass="custom-filter-btn advanced-filter-action" (click)="clearFilter()"></p-button>
            <p-button label="Cancel" icon="pi pi-times" severity="info" styleClass="custom-filter-btn advanced-filter-action" (click)="closeFilterModal()"></p-button>
            <p-button label="Submit" icon="pi pi-check" severity="info" styleClass="custom-filter-btn advanced-filter-action" (click)="submitFilter(); this.filterDialog=false"></p-button>
          </div>
        </div>


      </div>


    </div>

    <p-footer class="float-right">


    </p-footer>
  </p-dialog>

  <p-dialog header="Select Options" [(visible)]="isPrintVariance" class="popUpHeader" [style]="{width: '30vw'}">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group selectCheck checkbox-inline">
          <input type="checkbox" name="deIdentifyData" [(ngModel)]="filter.deIdentifyData" class="selectCheck" style="margin-right: 8px; vertical-align: middle;">
          <label class="form-check-label" style="margin-bottom: 0; vertical-align: middle;">De-Identify Data</label>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group selectCheck checkbox-inline">
          <input type="checkbox" name="allAdcEhr" [(ngModel)]="filter.allAdcEhr" class="selectCheck" style="margin-right: 8px; vertical-align: middle;">
          <label class="form-check-label" style="margin-bottom: 0; vertical-align: middle;">Show All ADC and EHR Data</label>
        </div>
      </div>
    </div>
    <div class="form-group float-right mt-3">
      <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-sm" (click)="this.isPrintVariance=false"></p-button>
      <p-button label="Submit" icon="pi pi-check" styleClass="p-button-sm" (click)="submitPrintFilter()" (click)="this.isPrintVariance=false "></p-button>
    </div>
  </p-dialog>

  <div class="filter">
    <p-dialog
      header="Filter Data"
      [style]="{width: '60vw'}"
      class="filterHeader"
      [(visible)]="linkFilterDialog">
       <div class="row">
          <div class="col-md-6 d-flex flex-column align-items-center">
            <div class="form-group w-75 mx-auto">
                <label for="start_date">Start Date</label>
                <p-datepicker appendTo="body" (onSelect)="updateEndDate()" [(ngModel)]="filter.startDate"></p-datepicker> 
            </div>
            <div class="form-group w-75" style="margin: 0 auto;">
              <label for="pwd">User ID</label>
              <ng-select multiple="true" [(ngModel)]="filter.lanID" [items]="filterOptions.lanID"  (search)="searchWithAutoComplete($event,'lanID','lanID')"></ng-select>  
            </div>
            <div class="form-group w-75" style="margin: 0 auto;">
              <label>Role</label>
              <ng-select multiple="true" bindValue="value" (clear)="resetCode('UserType')" appendTo="body" [(ngModel)]="filter.UserType" [items]="filterOptions.adminType" placeholder="" [virtualScroll]=true [searchFn]="ngSelectSearch"></ng-select>
            </div>
            <div class="form-group w-75" style="margin: 0 auto;">
              <label>Stock Area</label>
              <ng-select multiple="true" bindValue="value" (clear)="resetCode('bedDev')" appendTo="body" [items]="filterOptions.loc" [(ngModel)]="filter.bedDev" placeholder="" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
            </div>
            <div class="form-group w-75" style="margin: 0 auto;">
              <label>Transaction Type</label>
              <ng-select multiple="true" bindValue="value" (clear)="resetCode('TransactionType')" appendTo="body" [items]="filterOptions.transactionType" [(ngModel)]="filter.TransactionType" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group w-75" style="margin: 0; text-align: left; align-items: flex-start;">
              <label for="end_date" style="display: block; text-align: left;">End Date</label>
              <div style="width: 100%; display: flex; justify-content: flex-start;">
                <p-datepicker appendTo="body" [(ngModel)]="filter.endDate" inputId="end_date" style="width: 100%;"></p-datepicker>
              </div>
            </div>
            <div class="form-group w-75" style="margin: 0 auto;">
              <label for="pwd">Patient ID:</label>
              <ng-select multiple="true" [(ngModel)]="filter.mrnNum" [items]="filterOptions.patientId"  (search)="searchWithAutoComplete($event,'patientId','patientid')"></ng-select>          
            </div>
            <div class="form-group w-75" style="margin: 0 auto;">
              <label>Medication Description</label>
              <ng-select multiple="true" bindValue="value" (clear)="resetCode('description')" appendTo="body" [items]="filterOptions.medDescription" [(ngModel)]="filter.description" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
            </div>
            <div class="form-group">
              <label>Unit of Measure</label>
              <ng-select multiple="true" bindValue="value" (clear)="resetCode('uom')" appendTo="body" [items]="filterOptions.uom" [(ngModel)]="filter.uom" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
            </div>
            <div class="form-group">
              <label>Data Source</label>
              <ng-select multiple="true" bindValue="value" (clear)="resetCode('RecordType')" appendTo="body" [items]="filterOptions.recordType" [(ngModel)]="filter.RecordType" [virtualScroll]=true [searchFn]="ngSelectSearch"> </ng-select>
            </div>
            <p-footer>
              <div class="form-group float-right mt-3">
                <p-button label="Clear" icon="pi pi-trash" severity="info" class="ml-2" (click)="clearFilter()"></p-button>
                <p-button label="Cancel" icon="pi pi-times" severity="info" class="ml-2" (click)="closeFilterModal()"></p-button>
                <p-button label="Submit" icon="pi pi-check" severity="info" class="ml-2" (click)="submitFilter(); this.linkFilterDialog=false"></p-button>
              </div>
            </p-footer>
          </div>
        </div> 
      <p-footer class="float-right"> </p-footer>
    </p-dialog> 
  </div>
  <p-dialog
  position ="right"
  header="EHR Notes"
  [(visible)] ='physicianOrder'
  [style]="{'width':'20vw', 'height':'30vh'}" class="popUpHeader physician-order-dialog">
    <app-physician-orders appendTo="body" #physicianOrdersModal></app-physician-orders>
  </p-dialog>

  <p-dialog header="VIEW/ADD NEW COMMENTS and VIEW/UPDATE WASTE" [style]="{width: '60vw'}" class="comment-modal"
    [(visible)]="wmCommentDialog">
    <app-wm-comment-modal #wmCommentModal [selectedRow]="selectedRow" [deId]="deId" (completed)="submitMessageCompleted($event)">
    </app-wm-comment-modal>
  </p-dialog>
  
  <!-- It was showing 2 filter pills, variance module shares a app-filter-pill in variacne.component.html -->
    <!-- <app-data-filter-pills 
    [filterValues]="filter" 
    [deId]="deId"
    (filterVal)="removeVarianceFilters($event, filter.duration)"S
    (filterInputs)="openFilterModal()">
  </app-data-filter-pills> -->

  <p-dialog [(visible)]="searchDialog" [showHeader]="false" [modal]="true" [closable]="true" [dismissableMask]="true"
          [style]="{ width: '28rem'}" styleClass="rounded-dialog" [baseZIndex]="10000" appendTo="body">
  <div class="search-bar">
      <i tabindex="0" class="pi pi-search mr-2" pTooltip="click to search" tooltipPosition="bottom" (click)="submitGlobalFilter()" (keydown.enter)="submitGlobalFilter()" (click)="this.searchDialog=false" (keydown.enter)="this.searchDialog=false" style="margin: 4px 2px 0 0"></i>
      <input type="text" placeholder="Table Search" pInputText 
        [(ngModel)]="filter.globalSearch"
        (keyup.enter)="submitGlobalFilter()" (keyup.enter)="this.searchDialog=false"
        class="searchStyle" [pAutoFocus]="true" />
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer-message">Hit enter to search</div>
  </ng-template>
</p-dialog>
</div>
